import { Typography } from 'design-system/src/components/Typography/Typography';
import styled from 'styled-components';
import { FormCompletionStats } from '../../lib/formFiller';

export const ProgressMessageContainer = styled.div`
  font-size: 14px;
  color: var(--grayscale-600);
`;

export const ProgressMessage = ({ completionStats }: { completionStats: FormCompletionStats }) => {
  // Generate progress message based on current state
  const getProgressMessage = (): string => {
    if (completionStats.isComplete) {
      return 'When you are done reviewing the document, please click the Submit button.';
    }

    const remaining = completionStats.remainingRequired;
    return `${remaining} field${remaining !== 1 ? 's' : ''} remaining`;
  };
  return (
    <ProgressMessageContainer>
      <Typography styledAs="bodySmallSpaceGrotesk" color="var(--purple-700)" weight={500}>
        {getProgressMessage()}
      </Typography>
    </ProgressMessageContainer>
  );
};
